var plugin_rtlignore_default = {
  "alignLeft": "RCvHO",
  "textWrapNowrap": "tO5bs",
  "alignRight": "KdCgw",
  "alignCenter": "_23MBI",
  "sizeFullWidth": "BAaCk",
  "renderedInTable": "u-LuO",
  "sizeOriginal": "IJRud",
  "sizeContent": "_5un9y",
  "sizeSmall": "aZngd",
  "sizeSmallCenter": "_04ClM",
  "flex": "CbMES",
  "atomic": "_0Fn20",
  "embed": "_4qNdB",
  "horizontalScrollbar": "vEDtT",
  "pluginContainerMobile": "dh-DK"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
